import { useParams } from 'react-router-dom';

import { AppLegalDocumentsPage } from '~/components/pages/AppLegalDocumentsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppLegalDocumentsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppLegalDocumentsPage appId={appId} />
    </DashboardTemplate>
  );
};
